import { apiClient } from '../../../../services/apiClient'
import type {
  Listing,
  ListingSearchRequest,
  ListingSearchResponse,
} from '@popety-io/types'

export const listingService = {
  /**
   * Get a single listing by ID
   */
  async getListing(id: string, fields?: string[]): Promise<Listing> {
    const query = fields
      ? `?fields=${encodeURIComponent(fields.join(','))}`
      : ''

    const url = `/listings/${id}${query}`
    const response = await apiClient.get(url)
    return response.data
  },

  /**
   * Get multiple listings by IDs (bulk endpoint)
   */
  async getListings(ids: string[], fields?: string[]): Promise<Listing[]> {
    if (!ids || ids.length === 0) {
      return []
    }

    // Limit to 100 IDs per request as per API constraints
    const limitedIds = ids.slice(0, 100)

    const params = new URLSearchParams()
    params.append('ids', limitedIds.join(','))

    if (fields && fields.length > 0) {
      params.append('fields', fields.join(','))
    }

    const url = `/listings/bulk?${params.toString()}`
    const response = await apiClient.get(url)
    return response.data
  },

  /**
   * Search for listings with filters
   */
  async searchListings(
    request: ListingSearchRequest
  ): Promise<ListingSearchResponse> {
    const response = await apiClient.post('/listings/search', request)
    return response.data
  },

  /**
   * Get listing data optimized for history display
   */
  async getListingForHistory(id: string): Promise<Listing> {
    const fields = [
      'id',
      'listing_timestamp',
      'deal_type',
      'price',
      'price_per_square_meter',
      'area',
      'land_area',
      'rooms_nb',
      'property_category',
      'property_type',
      'active',
      'description',
      'broker_info',
      'listing_duration',
      'address',
      'city_name',
      'municipality_name',
      'construction_year',
      'floor',
      'bathroom_nb',
      'urls_image',
      'features',
      'PetsAllowed',
      'IsFurnished',
      'AvailableDate',
      'geo_center',
    ]

    return this.getListing(id, fields)
  },

  /**
   * Get multiple listings optimized for history display
   */
  async getListingsForHistory(ids: string[]): Promise<Listing[]> {
    const fields = [
      'id',
      'listing_timestamp',
      'deal_type',
      'price',
      'price_per_square_meter',
      'area',
      'land_area',
      'rooms_nb',
      'property_category',
      'property_type',
      'active',
      'description',
      'broker_info',
      'listing_duration',
      'address',
      'city_name',
      'municipality_name',
      'construction_year',
      'floor',
      'bathroom_nb',
      'urls_image',
      'features',
      'PetsAllowed',
      'IsFurnished',
      'AvailableDate',
      'geo_center',
    ]

    return this.getListings(ids, fields)
  },
}
